import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Router } from '@angular/router';

import { createCsv } from '@fitogest/reactive-form-builder/csv';
import { FormType, Value } from '@fitogest/reactive-form-builder/interfaces';
import { RequestHandler } from '../../../../service/OffService/request-handler';
import { Filtering } from '../../../../service/filtering/filtering';
import { BaseView } from '../../../base-view';
import { TareasApiService } from '../../../../service/api/tareas-api.service';
import { environment } from '../../../../../environments/environment';
import { StorageManager } from '../../../../common/storage-manager.class';
import { build, list, stack } from '../../../../common/classes/request-builder';
import moment from 'moment';
import { Utils } from '../../../../common/utils';
import { FincasApiService } from '../../../../service/api/fincas-api.service';
import { SiexApiService } from '../../../../service/api/siex-api.service';
import { DashboardService } from '../../../../service/events/dashboard.service';
import { TareaSiembraModel } from '../../../../models/tareas/tarea-siembra.model';
import { ColInterface } from '../../../../common/components/common-list-table/col.interface';
import { ParcelasModel } from '../../../../models/form-common/parcelas.model';
import { TreeNode } from 'primeng/api';
import { SiembraFormDefinition } from './siembra-form/form-control/form-definition';
import { getDropdownSelectedSingle } from '@fitogest/reactive-form-builder/utils';

@Component({
    selector: 'app-siembra',
    standalone: false,
    templateUrl: './siembra.component.html',
    styleUrls: ['./siembra.component.scss']
})

export class SiembraComponent extends BaseView<TareaSiembraModel> implements OnInit {
    public years = [
        {label: '...', value: 0},
    ];
    public showTareasBioExportCsv = environment.features.showTareasBioExportCsv;
    public tipoAplicacion =  environment.features.applicationType;
    public serverUrl = environment.serverUrl;
    public appName = environment.appName;
    public horticola = environment.features.horticola;
    public readonly selectedYearsControl = new FormControl<number>(0, { nonNullable: true });
    public modalShowCampaign  = false;
    public showCampaign = environment.features.showTareasSiembraCampaign;

    public addButtonText = this.horticola ? 'Añadir Cultivo' : 'Añadir Tarea';
    public rolUser = StorageManager.getUser().rol;

    public hasClients = environment.features.hasClients;
    public userCanSeeClientes = this.hasClients &&
        (environment.features.userCanSeeClientes ? true : (StorageManager.getUser().rol === 'admin'));
    public clienteName = environment.features.clienteName;
    public fincaName = environment.features.fincaName;
    public sectorName = environment.features.sectorName;
    public parcelasName = environment.features.parcelasName;
    public showTareasSiembraProductos = environment.features.showTareasSiembraProductos;
    public showHorticola = environment.features.horticola;

    public parcelas = list<ParcelasModel>();
    public cultivos = list();
    public form: SiembraFormDefinition | null = null;
    
    public filter: Filtering<TareaSiembraModel> = new Filtering<TareaSiembraModel>();
    public getRequest: RequestHandler<TareaSiembraModel[]> = this.tareasApi.siembra.GET;
    public deleteRequest: RequestHandler<TareaSiembraModel> = this.tareasApi.siembra.DELETE;
    public menuItemId = 'tareas-siembra';

    public override canShow: Record<string, boolean> = {};
    public override model: TareaSiembraModel = {};

    public cols: ColInterface[] = [
        {
            field: 'fecha_inicio',
            header: 'Inicio',
            filter: '',
            visible: environment.appName !== 'cartagenafresh'
        },
        {
            field: 'fecha_fin',
            header: environment.appName === 'cartagenafresh' ? 'Fecha Plantación' : 'Fin',
            filter: ''
        },        
        {
            field: 'cliente_nombre',
            header: this.clienteName,
            filter: '',
            visible: environment.features.applicationType !== 'agrogest' ? true : false,
        },
        {
            field: 'finca_nombre',
            header: this.fincaName,
            filter: ''
        },
        {
            field: 'sector_nombre',
            header: this.sectorName,
            filter: ''
        },
        {
            field: 'parcelas_nombres',
            header: this.parcelasName,
            filter: ''
        },
        {
            field: 'cultivos_nombres',
            header: 'Cultivo',
            filter: ''
        },
        {
            field: 'variedades_nombres',
            header: 'Variedad',
            filter: ''
        },
        {
            field: 'dosis_siembra',
            header: 'Dosis Kg/Ha',
            filter: ''
        },
        {
            field: 'cultivo_precedente',
            header: 'Cultivo precedente',
            filter: '',
            visible: environment.appName !== 'cartagenafresh'
        },
        {
            field: environment.appName === 'pyf' ? 'tipo_labor' : 'observaciones',
            header: environment.appName === 'pyf' ? 'Tipo de Labor' : 'Observaciones',
            filter: ''
        },
        { field: 'facturado', header: 'Facturado', filter: '', visible: environment.appName === 'agrosalvi'}

    ];
    
    public colsViverogest: ColInterface[] = [
        {
            field: 'fecha_siembra',
            header: 'Fecha Siembra',
            filter: ''
        },
        {
            field: 'fecha_descarga',
            header: 'Fecha Descarga',
            filter: ''
        },        
        {
            field: 'cliente_nombre',
            header: this.clienteName,
            filter: '',
            visible: environment.features.applicationType !== 'agrogest' ? true : false,
        },
        {
            field: 'finca_nombre',
            header: this.fincaName,
            filter: ''
        },
        {
            field: 'sector_nombre',
            header: this.sectorName,
            filter: ''
        },
        {
            field: 'parcelas_nombres',
            header: this.parcelasName,
            filter: ''
        },
        {
            field: 'cultivos_nombres',
            header: 'Cultivo',
            filter: ''
        },
        {
            field: 'variedades_nombres',
            header: 'Variedad',
            filter: ''
        },
        {
            field: 'cantidad_semilla',
            header: 'Cantidad Semilla',
            filter: ''
        },
        {
            field: 'semana_entrega',
            header: 'Semana Entrega',
            filter: ''
        },
        {
            field: 'no_esta',
            header: 'No Está',
            filter: ''
        }
    ];

    public colsHorticola: ColInterface[] = [
        {
            field: 'fecha_inicio',
            header: 'Fecha Inicio',
            filter: ''
        },
        {
            field: 'fecha_fin',
            header: 'Fecha Fin',
            filter: ''
        },        
        {
            field: 'finca_nombre',
            header: this.fincaName,
            filter: ''
        },
        {
            field: 'sector_nombre',
            header: this.sectorName,
            filter: ''
        },
        {
            field: 'parcelas_nombres',
            header: this.parcelasName,
            filter: ''
        },
        {
            field: 'cultivo',
            header: 'Cultivo',
            filter: ''
        },
        {
            field: 'variedad',
            header: 'Variedad',
            filter: ''
        },
    ];

    constructor(
        public tareasApi: TareasApiService,
        private fincasApi: FincasApiService,
        private siexApi: SiexApiService,
        private dashboard: DashboardService,
        private router: Router,
    ) {
        super(dashboard, tareasApi.siembra.GET, tareasApi.siembra.DELETE);
    }

    ngOnInit() {
        this.dashboard.setSubmenuItem(this.showHorticola ? 'fincas' : 'tareas', this.menuItemId);
        if ( this.showCampaign ) {
            this.fillCampaign();
            this.filter.addFilter((copy: TreeNode<TareaSiembraModel>[] | void) => (copy as TreeNode<TareaSiembraModel>[]).filter(row => {
                if (this.selectedYearsControl.value === 0) {
                    return true;
                } else {
                    return this.compareDates(row);
                }
            }));
        }
        stack([
            build(
                this.fincasApi.parcelasGET, 
                this.parcelas, ((it: ParcelasModel) => (it.variedad || 'Sin variedad') + ' (' + it.cultivo + ')'), 
                true
            ),
            build(this.siexApi.cultivosGET, this.cultivos, 'cultivo', true),
        ]).then(() => {
            this.filterVariedades();
            this.filter.filter();
            return;
        }).catch (e => {
            console.log('catch en stack: ' + e);
        }
        );
      
        this.filter.addFilter((data: TreeNode<TareaSiembraModel>[] | void) => 
            (data || []).filter((finca: TreeNode<TareaSiembraModel>) => finca && (finca as Record<string,string>)['id']));
        
    }

    public add() {
        if (!StorageManager.getClient() && this.userCanSeeClientes) {
            this.dashboard.openClientDialog();
        } else {
            this.router.navigate(['dashboard', 'tareas-crear-siembra']);
        }
    }

    public duplicate(data: TareaSiembraModel) {
        this.router.navigate(['dashboard', 'tareas-duplicar-siembra', data.id]);
    }

    public edit(data: TareaSiembraModel) {
        this.router.navigate(['dashboard', 'tareas-editar-siembra', data.id]);
    }

    public override show(modal: string, data: TareaSiembraModel) {
        super.show(modal, data);

        const formType = modal === 'delete' ? +FormType.DELETION : +FormType.INFORMATIVE;
        this.form = new SiembraFormDefinition(formType, data);
    }

    public override hide(modal: string): void {
        super.hide(modal);
        this.form = null;
    }

    modalCampaign() {
        this.modalShowCampaign = true;
    }

    closeModalShowCampaign() {
        this.modalShowCampaign = false;
    }

    selectedCampaign(){
        this.filter.filter();
    }

    compareDates( row: TreeNode<TareaSiembraModel> ) {
        const tareaSiembra = row.data ?? row as TareaSiembraModel;
        const fechaInicio = tareaSiembra.fecha_inicio;

        if (typeof fechaInicio !== 'string' || fechaInicio.length === 0) {
            return false;
        }
        
        const auxFecha = fechaInicio.split('/');
        const nuevaFecha = moment(auxFecha[2] + '-' + auxFecha[1] + '-' + auxFecha[0] );
        const selectedYears = this.selectedYearsControl.value;
        const fechaComparar = moment('20' + selectedYears.toString() + '-07' + '-01');
        const fechaMax = moment('20' + (selectedYears + 1).toString() + '-06' + '-30');

        if ( (nuevaFecha > fechaComparar) && (nuevaFecha < fechaMax) ){
            return true;
        } else {
            return false;
        }
    }
    
    /**
     *  Rellena el listado de campañas
     */
    fillCampaign () {
        const fechaActual = new Date().getFullYear();
        let fechaDosDigitos = 0;
        
        for (let index = 2020; index <= fechaActual; index++) {

            fechaDosDigitos = parseInt( (index.toString()).substring(2, 4) , 10);
            this.years.push({ label: index.toString() + '-' + (fechaDosDigitos + 1 ).toString(), value: fechaDosDigitos });
            
        }
    }

    public downloadCsv() {
        this.form = new SiembraFormDefinition(+FormType.EXPORT, {});
        const csvContent = createCsv(
            this.form.fieldNames,
            this.form.fieldLabels,
            this.filter.value as TareaSiembraModel[],
        );
        const csvLink = document.getElementById('csvLink') as HTMLAnchorElement | null;

        if (!csvLink) {
            return;
        }

        csvLink.download = `${this.form.formFields.name}.csv`;
        csvLink.href = encodeURI(csvContent);
        csvLink.click();
    }

    public globalVisualTransform(value: string, col: ColInterface) {
       
        if (
            col.field === 'parcelas_nombres' || 
            col.field === 'cultivos_nombres' ||
            col.field === 'variedades_nombres') {
            return (value.length > 50) ? value.slice(0, 50 - 1) + '…' : value;
        }

        if (col.field === 'facturado') {
            switch (value) {
            case '0':
                return 'No';
            case '1':
                return 'Sí';
            default:
                return 'No';
            }
        }
        return value;
    }

    // PETICIÓN GET PARA GENERAR CUADERNO 
    public generarCuaderno() {
        if (!this.model.fecha_inicio || !this.model.fecha_fin) {
            alert('Debe especificar un intervalo de fechas.');
            return;
        }
        let idCultivo = '';

        const selectedParcela = getDropdownSelectedSingle(this.parcelas) as ParcelasModel | null;
        idCultivo = selectedParcela == null ? '' : selectedParcela.id_cultivo ?? '';

        let cuadernoFields = '?id_cultivo=' + idCultivo;

        const interval = this.getDates(this.model.fecha_inicio, this.model.fecha_fin);
        const fechaFin = interval.fechaFin;
        const fechaInicio = interval.fechaInicio;
        const anyo2 = interval.anyo;
        cuadernoFields += '&fecha_fin=' + fechaFin +
    '&fecha_inicio=' + fechaInicio + '&anyo=' + anyo2;

        window.open((this.serverUrl + 'ws/informes/index.php' + cuadernoFields), '_blank');
    }

    public getDates(inicio: string | Date, fin: string | Date): {fechaInicio: string, fechaFin: string, anyo: string} {
        const fechaInicio = (inicio instanceof Date) ? Utils.formatDate(inicio) : inicio;
        const fechaFin = (fin instanceof Date) ? Utils.formatDate(fin) : fin;
  
        // Si no hay año se calcula con los años de la fecha de inicio y de fin (2017-2018)
        let anyo = fechaInicio.split('/')[2] ?? '';
        anyo = fechaInicio.split('/')[2] + '-' + fechaFin.split('/')[2];
        if (fechaInicio.split('/')[2] === fechaFin.split('/')[2]) { anyo = fechaInicio.split('/')[2] ?? ''; }
  
        return {fechaInicio, fechaFin, anyo};
    }

    public filterVariedades() {
        const repes: string[] = [];
        this.parcelas.values = this.parcelas.values
            .map((it): Value<any> | null => {
                if (
                    it.value &&
                    !repes.includes(`${it.label}_${it.value.id_finca}_${it.value.id_sector}`)
                ) {
                    repes.push(`${it.label}_${it.value.id_finca}_${it.value.id_sector}`);
                    return it;
                }

                return null;
            })
            .filter((it): it is Value<any> => it !== null);
    }

}
